import { useState, useEffect } from "react"
import {
  Box,
  Typography,
  Card,
  CardContent,
  Button,
  Grid,
  Checkbox,
  FormControlLabel,
  IconButton,
} from "@mui/material"
import ApiService from "../../_services/ApiService";
import RichTextEditor from "../../components/reusableComponents/ResuableRichTextEditor"
import ReusableNumberComponent from '../../components/reusableComponents/ReusableNumberComponent';
import ReusableComponent from "../../components/reusableComponents/reusableInputComponents";
import ReusableCheckboxGroup from "../../components/reusableComponents/reusableCheckboxGroup ";
import ReusableMultiComponent from "../../components/reusableComponents/ReusableMultiComponent";
import { eligibleRequirement } from "../../_helpers/reusablefunctions/eligibleRequirement";
import ReusableMuiIcons from "../../_helpers/ReusableMuiIcons";
import { useParams } from "react-router-dom";
import { normalizeTargetingFields } from "../../_helpers/normalizeFormData";

// Mirrors CommissionRule.RateType in GNBrand. The values are what the API
// stores, so they are sent verbatim rather than mapped.
const commissionRateTypeOptions = [
  { label: 'Percentage of sale', value: 'PERCENT' },
  { label: 'Flat amount per unit', value: 'FLAT' },
];

const ContentTargeting = ({ formData, setFormData, barterId, sections, setSections, isEditMode, formErrors, setFormErrors }) => {
  const requirement = eligibleRequirement();
  const [eligibleRequirementSelection, setEligibleRequirementSelection] = useState([]);
  const [audienceOptions, setAudienceOptions] = useState([]);
  const [influencerOptions, setInfluencerOptions] = useState([]);
  const [cityOptions, setCityOptions] = useState([]);
  const [platformOptions, setPlatformOptions] = useState([]);
  const [auidenceInterest, setAuidenceInterest] = useState([]);
  const { offerId } = useParams();
  const [editedSections, setEditedSections] = useState([]);
  const [hasNormalized, setHasNormalized] = useState(false);


  const contentRequirements = [
    { value: '1', label: 'Reel' },
    { value: '2', label: 'Post' },
    { value: '3', label: 'Video' },
    { value: '4', label: 'Story' },
    { value: '5', label: 'Testimonial' }
  ]

  const genderOption = [
    { value: '1', label: 'Male' },
    { value: '2', label: 'Female' },
    { value: '3', label: 'Other' }
  ]

  const submitContentRequirements = async (sectionsData) => {
    const filteredSections = sectionsData.filter(
      (section) => section.format?.label && section.quantities
    );

    try {
      for (const section of filteredSections) {
        const payload = {
          format: section.format.label,
          quantities: section.quantities,
        };

        if (section.id) {
          await ApiService.put("content_requirements", payload, { id: section.id });
          console.log("Content requirement updated successfully");
        } else {
          const formDataToSend = new FormData();
          const idToSend = isEditMode ? offerId : barterId;

          formDataToSend.append("barter", idToSend);
          formDataToSend.append("format", section.format.label);
          formDataToSend.append("quantities", section.quantities);

          const response = await ApiService.post("content_requirements", formDataToSend);

          const sectionIndex = sections.findIndex(s =>
            s.format?.label === section.format.label &&
            s.quantities === section.quantities &&
            !s.id
          );

          if (sectionIndex !== -1 && response.data?.id) {
            setSections(prevSections => {
              const updated = [...prevSections];
              updated[sectionIndex] = { ...updated[sectionIndex], id: response.data.id };
              return updated;
            });
          }

          console.log("Content requirement created successfully");
        }
      }
    } catch (error) {
      console.error("Failed to submit content requirements:", error);
    }
  };
  const handleInputChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }))

    if (formErrors?.[field]) {
      setFormErrors((prev) => ({ ...prev, [field]: "" }));
    }
  };

  const handlePlatformChange = (platform) => {
    setFormData((prev) => {
      const existingPlatforms = prev.platforms || {};
      const updatedPlatforms = {
        ...existingPlatforms,
        [platform]: !existingPlatforms[platform],
      };

      if (Object.values(updatedPlatforms).some(val => val)) {
        setFormErrors((prevErrors) => ({ ...prevErrors, platforms: "" }));
      }

      return {
        ...prev,
        platforms: updatedPlatforms,
      };
    });
  };

  const SectionTitle = ({ children }) => (
    <Typography sx={{ fontWeight: 500, fontSize: 18, color: '#626478', marginBottom: '10px', display: 'flex', gap: '9px' }}>
      {children}
    </Typography>
  );

  useEffect(() => {
    if (Array.isArray(formData.audience_type) && audienceOptions.length) {
      if (formData.audience_type[0]?.value && formData.audience_type[0]?.label) {
        setEligibleRequirementSelection(formData.audience_type);
      } else {
        const matchedOptions = audienceOptions.filter((item) =>
          formData.audience_type.includes(item.value)
        );
        setEligibleRequirementSelection(matchedOptions);
      }
    }
  }, [formData.audience_type, audienceOptions]);


  useEffect(() => {
    const fetchAllOptions = async () => {
      try {
        const [audienceRes, influencerRes, cityRes, platformRes, offerEligibleRes] = await Promise.all([
          ApiService.get('audience_type'),
          ApiService.get('influencer_tier'),
          ApiService.get('city'),
          ApiService.get('platform'),
          ApiService.get('offers_eligible'),
        ]);
        setAudienceOptions(audienceRes.data.results.map(item => ({ value: item.id, label: item.type })));
        setInfluencerOptions(influencerRes.data.results.map(item => ({ value: item.id, label: item.influencer_type })));
        setCityOptions(cityRes.data.results.map(item => ({ value: item.id, label: item.city_name })));
        setPlatformOptions(platformRes.data.results.map(item => ({ value: item.id, label: item.platformName, icon: item.platform_logo })))
        setAuidenceInterest(offerEligibleRes.data.data.map(item => ({ value: item.id, label: item.TypeName })));
      } catch (error) {
        console.error("Error fetching targeting options:", error);
      }
    };
    fetchAllOptions();
  }, []);

  useEffect(() => {
    const optionsReady =
      audienceOptions.length > 0 &&
      influencerOptions.length > 0 &&
      cityOptions.length > 0 &&
      platformOptions.length > 0 &&
      auidenceInterest.length > 0;

    if (isEditMode && !hasNormalized && optionsReady) {
      normalizeTargetingFields({ formData, setFormData, setSections });
      setHasNormalized(true);
    }
  }, [
    isEditMode,
    hasNormalized,
    audienceOptions,
    influencerOptions,
    cityOptions,
    platformOptions,
    auidenceInterest,
  ]);

  useEffect(() => {
    if (!formData.platforms || typeof formData.platforms !== "object") {
      setFormData((prev) => ({ ...prev, platforms: {} }));
    }
  }, []);

  useEffect(() => {
    if (hasNormalized && sections.length === 0) {
      setSections([{ format: { label: "" }, quantities: "" }]);
    }
  }, [hasNormalized, sections]);

  const handleEligibleRequirementSelection = (selected) => {
    setEligibleRequirementSelection(selected);
    setFormData(prev => ({ ...prev, audience_type: selected }));

    if (formErrors?.audience_type) {
      setFormErrors(prev => ({ ...prev, audience_type: "" }));
    }
  };

  const handleInfluencerTierChange = (selected) => {
    setFormData(prev => ({ ...prev, influencer_tier: selected }));

    if (formErrors?.influencer_tier) {
      setFormErrors(prev => ({ ...prev, influencer_tier: "" }));
    }
  };


  const handleCitySelection = (selectedCities) => {
    setFormData(prev => ({
      ...prev,
      cities: selectedCities,
    }));
  };

  const handleOffersEligible = (selectedOfferEligible) => {
    setFormData(prev => ({
      ...prev,
      offer_type: Array.isArray(selectedOfferEligible) ? selectedOfferEligible.filter(Boolean) : (selectedOfferEligible ? [selectedOfferEligible] : []),
    }));

    if (formErrors?.offer_type) {
      setFormErrors(prev => ({ ...prev, offer_type: "" }));
    }
  };


  const handleAddSection = () => {
    if (sections.length < 5) {
      setSections([...sections, { format: { label: "" }, quantities: "" }]);
    }
  };

  const handleDeleteSection = async (indexToRemove) => {
    const sectionToDelete = sections[indexToRemove];

    if (isEditMode && sectionToDelete.id) {
      try {
        await ApiService.delete("content_requirements", { id: sectionToDelete.id });
        console.log("Content requirement deleted successfully");
      } catch (error) {
        console.error("Failed to delete content requirement:", error);
      }
    }

    const updated = sections.filter((_, index) => index !== indexToRemove);
    setSections(updated);
  };

  const handleFormatChange = (index, selectedOption) => {
    if (!selectedOption || !selectedOption.label) return;

    const isDuplicate = sections.some((section, idx) =>
      idx !== index && section.format?.label === selectedOption.label
    );

    if (isDuplicate) {
      setFormErrors((prev) => {
        const updated = [...(prev.sections || [])];
        if (!updated[index]) updated[index] = {};
        updated[index].format = "This format is already selected.";
        return { ...prev, sections: updated };
      });
      return;
    }

    const updated = [...sections];
    updated[index].format = selectedOption;
    setSections(updated);

    setEditedSections((prev) => {
      const copy = [...prev];
      copy[index] = { ...(copy[index] || {}), format: true };
      return copy;
    });

    clearSectionErrors(index, "format");
  };


  const clearSectionErrors = (index, field) => {
    if (formErrors.sections?.[index]?.[field]) {
      setFormErrors((prev) => {
        const updatedSections = [...(prev.sections || [])];
        if (!updatedSections[index]) updatedSections[index] = {};
        updatedSections[index][field] = "";
        return { ...prev, sections: updatedSections };
      });
    }
  };

  //  const handleNumberChange = (index, value) => {
  //   const updated = [...sections];
  //   updated[index].quantities = Number(value);
  //   setSections(updated);

  //   setEditedSections((prev) => {
  //     const copy = [...prev];
  //     copy[index] = { ...(copy[index] || {}), quantities: true };
  //     return copy;
  //   });

  //   clearSectionErrors(index, "quantities");
  // };

  // const handleBlur = async (index) => {
  //   const section = sections[index];
  //   const edited = editedSections[index];

  //   if (
  //     section.format?.label &&
  //     section.quantities &&
  //     edited &&
  //     (edited.format || edited.quantities)
  //   ) {
  //     await submitContentRequirements([section]);

  //     setEditedSections((prev) => {
  //       const copy = [...prev];
  //       copy[index] = {};
  //       return copy;
  //     });
  //   }
  // };

  const handleNumberChange = (index, value) => {
    const updated = [...sections];
    updated[index].quantities = Number(value);
    setSections(updated);

    setEditedSections((prev) => {
      const copy = [...prev];
      copy[index] = { ...(copy[index] || {}), quantities: true };
      return copy;
    });

    clearSectionErrors(index, "quantities");
  };

  const handleBlur = async (index) => {
    const section = sections[index];

    if (section.format?.label && section.quantities) {
      await submitContentRequirements([section]);

      setEditedSections((prev) => {
        const copy = [...prev];
        copy[index] = {};
        return copy;
      });
    }
  };

  return (
    <Box >
      <Grid container spacing={3}>
        <Grid item xs={12} md={6}>
          <Card sx={{ borderRadius: '10px', mb: 3 }}>
            <CardContent>
              <SectionTitle>Platforms To Target *</SectionTitle>
              <Box sx={{ mb: 2 }}>
                {platformOptions.map((platform) => (
                  <FormControlLabel
                    key={platform.value}
                    control={
                      <Checkbox
                        checked={!!formData.platforms?.[platform.value]}
                        // checked={formData.platforms[platform.value]}
                        onChange={() => handlePlatformChange(platform.value)}
                      />
                    }
                    label={
                      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                        <Box
                          sx={{
                            width: 24,
                            height: 24,
                            borderRadius: "50%",
                            // backgroundColor: "#00000010",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            // border: "1px solid #00000030",
                          }}
                        >
                          <img src={`https://college.groovenexus.com/media/${platform.icon}`}
                            //  src={platform.icon}
                            alt={platform.label} style={{ height: "28px" }} />
                        </Box>
                        {platform.label}
                      </Box>
                    }
                  />
                ))}
              </Box>
              {formErrors.platforms && (
                <Typography color="error" fontSize={13}>
                  {formErrors.platforms}
                </Typography>
              )}
            </CardContent>
          </Card>
          <Card sx={{ borderRadius: '10px', mb: 3 }}>
            <CardContent>
              <Box sx={{ alignItems: 'center', gap: '10px' }}>
                <SectionTitle>Content Requirements <Typography fontWeight="500" sx={{ fontSize: "14px", color: '#626478', paddingTop: '3px' }}>(Per Influencer) *</Typography></SectionTitle>
              </Box>

              {sections.map((section, index) => (
                <Grid container spacing={2} sx={{ mb: 2 }} key={index} alignItems="center">
                  <Grid item xs={5}>
                    <ReusableComponent
                      type="select"
                      label="Format"
                      placeholder="Select from dropdown"
                      // value={section?.format.label}
                      value={section?.format}
                      onChange={(value) => handleFormatChange(index, value)}
                      options={contentRequirements}
                      sx={{ paddingTop: '20px' }}
                      size="small"
                      error={!!formErrors.sections?.[index]?.format}
                      helperText={formErrors.sections?.[index]?.format}
                      onBlur={() => handleBlur(index)}
                    />
                  </Grid>
                  <Grid item xs={5}>
                    <ReusableNumberComponent
                      value={section.quantities}
                      onChange={(value) => handleNumberChange(index, value)}
                      onBlur={() => handleBlur(index)}
                      error={!!formErrors.sections?.[index]?.quantities}
                      helperText={formErrors.sections?.[index]?.quantities}
                    />
                  </Grid>
                  <Grid item xs={2} sx={{ textAlign: "right", mt: 2 }}>
                    {sections.length > 1 && (
                      <IconButton onClick={() => handleDeleteSection(index)}>
                        <ReusableMuiIcons name="delete" color="error" />
                      </IconButton>
                    )}
                  </Grid>
                </Grid>
              ))}

              {sections.length < 5 && (
                <Button
                  size="small"
                  variant="text"
                  onClick={handleAddSection}
                  startIcon={<ReusableMuiIcons name="addbox" sx={{ color: '#1976D2' }} />}
                  sx={{ color: "#7A7A7A", textTransform: "none" }}
                >
                  Add more
                </Button>
              )}
            </CardContent>
          </Card>

          <Card sx={{ borderRadius: '10px' }}>
            <CardContent>
              <RichTextEditor
                value={formData.redemption_steps}
                onChange={(value) => handleInputChange("redemption_steps", value)}
                placeholder="Write something ...."
                rows={6}
                minHeight={{ xs: 250, md: 150 }}
                title="How To Redeem / Redemption Steps"
                error={!!formErrors.redemption_steps}
                helperText={formErrors.redemption_steps}
                required={true}
                width={{ xs: '100%', md: "560px" }}
              />
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} md={6}>


          <Card sx={{ borderRadius: '10px' }}>
            <CardContent>
              <SectionTitle>Target Audience *</SectionTitle>
              <Box>
                <ReusableCheckboxGroup
                  title=""
                  options={audienceOptions}
                  selectedOptions={formData.audience_type}
                  setSelectedOptions={handleEligibleRequirementSelection}
                  optionLabel="label"
                  error={!!formErrors.audience_type}
                  helperText={formErrors.audience_type}
                />
              </Box>
              <Box>
                <ReusableMultiComponent label={'Influencer Tier'}
                  options={influencerOptions}
                  selectedOptions={formData.influencer_tier}
                  setSelectedOptions={handleInfluencerTierChange}
                  optionLabel="label"
                  error={!!formErrors.influencer_tier}
                  helperText={formErrors.influencer_tier}
                  requireValue
                />
              </Box>

              <Box>
                <ReusableMultiComponent label="Perferred Cities (Optional)"
                  options={cityOptions}
                  selectedOptions={formData.cities}
                  setSelectedOptions={handleCitySelection}
                  optionLabel="label"
                />
              </Box>

              <Box>
                <ReusableMultiComponent label="Audience Interests"
                  options={auidenceInterest}
                  selectedOptions={formData.offer_type}
                  setSelectedOptions={handleOffersEligible}
                  optionLabel="label"
                  error={!!formErrors.offer_type}
                  helperText={formErrors.offer_type}
                  requireValue
                />
              </Box>

              <Box sx={{ paddingTop: '12px' }}>
                <Grid container spacing={2}>
                  {/* <Grid item xs={4}>
                    <ReusableComponent
                      type="numeric"
                      label="Age From"
                      placeholder='Age From'
                      value={formData.from_age}
                      onChange={(value) => handleInputChange("from_age", value)}
                      error={!!formErrors.from_age}
                      helperText={formErrors.from_age}
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <ReusableComponent
                      type="numeric"
                      label="Age To"
                      placeholder='Age To'
                      value={formData.to_age}
                      onChange={(value) => handleInputChange("to_age", value)}
                      error={!!formErrors.to_age}
                      helperText={formErrors.to_age}
                    />
                  </Grid>  */}
                  <Grid item xs={12}>
                    <ReusableComponent
                      type="select"
                      label="Gender Specific"
                      placeholder='Select gender'
                      value={formData.gender}
                      onChange={(value) => handleInputChange("gender", value)}
                      options={genderOption}
                      error={!!formErrors.gender}
                      helperText={formErrors.gender}
                      requireValue
                    />
                  </Grid>
                </Grid>
              </Box>
            </CardContent>
          </Card>

          {/*
            Affiliate commission — what a creator earns PER SALE on this
            campaign, for the creators this campaign approves.

            Deliberately distinct from Payout above, which is a flat fee for
            producing content and is settled by the campaign itself. Both can
            be set; a paid collab that also earns commission is ordinary.

            Leaving both fields blank is the normal case and means "no
            affiliate commission" — which is what every campaign did before
            this existed. The rate only reaches approved creators: GNBrand
            resolves it per creator, so an applicant who is never approved
            keeps the brand's standing rate.

            The brand this rate belongs to is NOT asked for. The backend
            stamps it from the session, so a brand cannot attach its rate to
            another brand's catalog.
          */}
          <Card sx={{ borderRadius: '10px', mb: 3 }}>
            <CardContent>
              <SectionTitle>Affiliate commission (optional)</SectionTitle>
              <Typography
                variant="body2"
                sx={{ color: 'text.secondary', mb: 2, mt: 0.5 }}
              >
                Creators you approve for this campaign earn this rate on every
                sale they drive, instead of your standing rate. Leave blank if
                this campaign pays no commission.
              </Typography>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <ReusableComponent
                    type="select"
                    label="Rate type"
                    placeholder="Select rate type"
                    value={formData.commission_rate_type}
                    onChange={(value) =>
                      handleInputChange("commission_rate_type", value)}
                    options={commissionRateTypeOptions}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <ReusableComponent
                    type="text"
                    label={
                      formData.commission_rate_type === 'FLAT'
                        ? 'Amount per unit'
                        : 'Percentage of sale'
                    }
                    placeholder={
                      formData.commission_rate_type === 'FLAT'
                        ? 'e.g., 150'
                        : 'e.g., 18'
                    }
                    value={formData.commission_rate_value}
                    onChange={(value) =>
                      handleInputChange("commission_rate_value", value)}
                  />
                </Grid>
              </Grid>
            </CardContent>
          </Card>

          {/* <Card sx={{ borderRadius: '10px', mb: 3 }}>
            <CardContent>
              <SectionTitle>Payout</SectionTitle>
              <Grid item xs={12} sx={{ mb: 2, paddingTop: '10px' }}>
                <ReusableComponent type="text"
                  label="Enter Per Influencer"
                  placeholder={"e.g., ₹ 1,000"}
                  value={formData.payout}
                  onChange={(value) => handleInputChange("payout", value)}
                  // error={!!errors.Title}
                  // helperText={errors.Title}
                  requireValue={true}
                />
              </Grid>
            </CardContent>
          </Card> */}
        </Grid>
      </Grid>
    </Box>
  )
}

export default ContentTargeting
